export default {
    "mobile.openai.access.refused": "You are not authorized or your authorization has expired."
}